import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND}/api`;

axios.defaults.withCredentials = true;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function mediaUrl(url) {
  if (!url) return "";
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith("/api/media/")) return `${BACKEND}${url}`;
  return url;
}

export function sessionId() {
  let sid = "";
  try {
    sid = localStorage.getItem("svx_sid");
    if (!sid) {
      sid = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem("svx_sid", sid);
    }
  } catch (e) {
    sid = "anon";
  }
  return sid;
}

export function track(type, path) {
  try {
    fetch(`${API}/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ type, path: path || window.location.pathname, session_id: sessionId() }),
      keepalive: true,
    }).catch(() => {});
  } catch (e) {}
}

export function waLink(number, message) {
  const digits = String(number || "").replace(/\D/g, "");
  return `https://wa.me/${digits}?text=${encodeURIComponent(message || "")}`;
}

export function openWhatsApp(number, message, { trackType = "whatsapp_click", trackPath } = {}) {
  track(trackType, trackPath);
  window.open(waLink(number, message), "_blank", "noopener");
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(", ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
